import { Task } from '../../model/task/task.model';

export abstract class TaskRepository {
  abstract getTasks(): Promise<Task[]>;
  abstract addTask(title: string): Promise<Task>;
  abstract removeTask(id: string): Promise<void>;
  abstract toggleTask(id: string): Promise<Task>;
}
